import { RIBBON_ITEMS } from "@/data/content";

export default function Ribbon() {
  const items = [...RIBBON_ITEMS, ...RIBBON_ITEMS];
  return (
    <div data-testid="editorial-ribbon" className="overflow-hidden border-y border-atlantic/10 bg-sand-dark py-4" aria-hidden="true">
      <div className="marquee-track flex w-max items-center gap-8 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-8 text-[11px] font-semibold uppercase tracking-[0.3em] text-atlantic/60">
            {item}
            <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
          </span>
        ))}
      </div>
    </div>
  );
}
